import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReactNotification from 'react-notifications-component';
import './assets/fonts/flaticon/font/flaticon.css';
import './assets/fonts/icomoon/style.css';
import './styles/index.scss';
import App from './App';
import store from './store';
import AppErrorBoundary from './components/AppErrorBoundary/AppErrorBoundary';
import { initUser } from './helpers/initUser';
import { installSubscriptionInterceptor } from './helpers/subscriptionState';

import 'react-notifications-component/dist/theme.css';

import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import 'bootstrap/dist/js/bootstrap.bundle.min';

// Pull subscription state off every authenticated response. Must run
// before any component fires its first request so the banner is ready
// the moment expiry data lands. Idempotent on re-import.
installSubscriptionInterceptor();

var DEBUG = true;
if(!DEBUG){
    if(!window.console) window.console = {};
    var methods = ["log", "debug", "warn", "info"];
    for(var i=0;i<methods.length;i++){
        console[methods[i]] = function(){};
    }
}

initUser(store);

ReactDOM.render(
  <Provider store={store}>
    {/* <PersistGate persistor={persistor}> */}
    <Router>
      <ReactNotification />
      <div>
      <AppErrorBoundary>
        <App />
        {/* Legacy in-SPA WebSocket chat retired — replaced by the embeddable
            Prigmar chat widget (public/widget.js, loaded via the index.html
            script tag) so the brand widget is the single chat surface. */}
      </AppErrorBoundary>
      </div>
    </Router>
    {/* </PersistGate> */}
  </Provider>,
  document.getElementById('root'),
  );
